// extracted by mini-css-extract-plugin
export default {"storyDetailAdvertAvatar":"c-r_hi","storyDetailAdvertAvatar__image":"c-r_hj"};